import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'
import { ShippingCondition, ShippingRule } from 'common/types/shippingType'
import { centsToEuro, getReadablePrice } from 'common/utils/price-calculator'

export const getConditionLabel = (
  condition: ShippingCondition,
  rule: ShippingRule,
  t: TypedTFunctionInterface,
  language: string,
) => {
  switch (rule.type) {
    case 'price':
      if (condition.max) {
        return t('components.shipping.condition_label.price_icu', {
          min: getReadablePrice(
            centsToEuro(condition.min),
            rule.currency,
            language,
          ),
          max: getReadablePrice(
            centsToEuro(condition.max),
            rule.currency,
            language,
          ),
          currency: '',
        })
      }

      return t('components.shipping.condition_label.price_min_icu', {
        min: getReadablePrice(
          centsToEuro(condition.min),
          rule.currency,
          language,
        ),
        currency: '',
      })
    case 'quantity':
      if (condition.max) {
        return t('components.shipping.condition_label.quantity_icu', {
          min: condition.min,
          max: condition.max,
        })
      }

      return t('components.shipping.condition_label.quantity_min_icu', {
        min: condition.min,
      })
    case 'weight':
      if (condition.max) {
        return t('components.shipping.condition_label.weight_icu', {
          min: condition.min,
          max: condition.max,
        })
      }

      return t('components.shipping.condition_label.weight_min_icu', {
        min: condition.min,
      })
    default:
      return ''
  }
}

export const getShippingUnavailableMessage = (customerCountry?: string) => {
  if (!customerCountry) {
    return 'components.shipping.country_not_selected'
  }

  return 'components.shipping.not_available'
}
